import React from 'react';
import { Card, CardContent, Typography } from "@material-ui/core";
import './InfoBox.css';
function InfoBox({ title,cases,isRed,active,total, ...props }){
    return (
            <Card onClick = {props.onClick} className={`infoBox ${active && "infoBox--selected"} ${isRed && "infoBox--red"} `}> {/* if active is true add selected class */}
                <CardContent>
                    <Typography className="infoBox__title" color="textSecondary">
                        {title}
                    </Typography>
                    <h2 className={`infoBox__cases ${!isRed && "infoBox__cases--green"}`}>{cases}</h2>
                    <Typography className="infoBox__total" color="textSecondary">
                        {total} Total
                    </Typography>
                </CardContent>
            </Card>
    )
}

export default InfoBox

// Press rfce for Basic Structure Below
// import React from 'react'

// function InfoBox() {
//     return (
//         <div>
            
//         </div>
//     )
// }

// export default InfoBox
// 